import { render, staticRenderFns } from "./DialogSetting.vue?vue&type=template&id=6c068a6c&"
import script from "./DialogSetting.vue?vue&type=script&lang=js&"
export * from "./DialogSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogSetting.vue"
export default component.exports